import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { CONSTANTS } from '../utils/constants';
const BUYERS = [{
  name: 'Maria G.',
  city: 'Buenos Aires'
}, {
  name: 'Carmen L.',
  city: 'Città del Messico'
}, {
  name: 'Lucía F.',
  city: 'Madrid'
}, {
  name: 'Ana R.',
  city: 'Bogotá'
}, {
  name: 'Patricia M.',
  city: 'Santiago'
}, {
  name: 'Giulia T.',
  city: 'Roma'
}, {
  name: 'Francesca B.',
  city: 'Milano'
}, {
  name: 'Valentina S.',
  city: 'Napoli'
}, {
  name: 'Sofia C.',
  city: 'Firenze'
}, {
  name: 'Elena P.',
  city: 'Torino'
}, {
  name: 'Chiara D.',
  city: 'Bologna'
}, {
  name: 'Martina R.',
  city: 'Palermo'
}];
export function PurchasePopup() {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      toast.custom(t => <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-3 flex items-center gap-3 w-80 animate-in slide-in-from-bottom-5" data-id="element-247">
            <img src={CONSTANTS.IMAGES.MAIN} alt="Product" className="w-12 h-16 object-cover rounded-md shadow-sm" data-id="element-248" />
            <div className="flex flex-col" data-id="element-249">
              <span className="text-sm font-bold text-gray-900" data-id="element-250">
                {randomBuyer.name} da {randomBuyer.city}
              </span>
              <span className="text-xs text-gray-500 mt-0.5" data-id="element-251">
                Ha appena acquistato questo prodotto
              </span>
              <span className="text-[10px] text-green-600 font-medium mt-1 flex items-center gap-1" data-id="element-252">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-253"></span>
                Acquisto verificato
              </span>
            </div>
          </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
      // Schedule next popup between 15 and 30 seconds
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1)) + 15000;
      timeoutRef.current = setTimeout(showPopup, nextDelay);
    };
    // Initial popup after 10 seconds
    timeoutRef.current = setTimeout(showPopup, 10000);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return null; // This component only manages side effects (toasts)
}